<template>
  <div class="content_box">
    <!-- <div class="content_title">
      <div style="line-height:80px;background:#fff;padding-left:32px;font-family: PingFangSC-Semibold;
font-size: 20px;
color: #000000;
letter-spacing: 0;">
        对公账户
      </div>
    </div> -->
    <div style=" font-size: 16px;padding: 24px 32px !important;">
      银行卡
      <!-- <i
        class="el-icon-circle-plus-outline m_l12 f_16"
        style="color:#DC1E32;cursor: pointer;"
        @click="addCard"  v-if="cards && cards.length > 0 && cards.length <5"
      ></i> -->
    </div>
    <div class="card_box clearfix">
      <div v-for="item in cards" :key="item.id">
        <div class="card_item hasCard" v-if="item.status === 0" :style="{background:item.background}">
          <div style="display:flex">
            <div class="bankIcon">
              <img :src="item.imgSrc" alt="" width="100%">
            </div>
            <div class="item_content">
              <div style="word-break: break-all;" class="m_b16">{{item.bankName}}</div>
              <div style="word-break: break-all;" class="m_b16">{{item.bankCardNumber}}</div>
              <div style="word-break: break-all;" class="f_16">{{item.userName}}</div>
            </div>
          </div>
        </div>
        <div class="card_item toActive" v-if="item.status === -1" :style="{background:item.background}">
          <!-- <i class="el-icon-close" @click="handleDelete" style="position: absolute;right: 10px;top: 5px;font-size: 24px;cursor: pointer;"></i> -->
          <div style="display:flex">
            <div class="bankIcon">
              <img :src="item.imgSrc" alt="" width="100%">
            </div>
            <div class="item_content">
              <div style="word-break: break-all;" class="m_b16">{{item.bankName}}</div>
              <div style="word-break: break-all;" class="m_b16">{{item.bankCardNumber}}</div>
              <div class="f_16" style="color:#000;cursor: pointer;" @click="activeCard(item)">去激活&nbsp;></div>
            </div>
          </div>
        </div>
      </div>
       <div class="card_item" v-if="cards && cards.length >= 0 && cards.length <5">
        <div v-track="{ action: 'bank_addCard' }" class="card_plus" @click="addCard">
          <div style="text-align: center;">
            <i class="el-icon-circle-plus-outline" style="color: #DC1E32;font-size: 30px;"></i>
          </div>
          <div style="margin-top:12px;">
            <span style="color: #DC1E32;font-size: 18px;">添加银行卡</span>
          </div>
        </div>
      </div>
    </div>
    <div class="tips_box">
      <div style="margin-bottom:12px">说明</div>
      <div style="font-size: 14px;color: rgba(0,0,0,0.45)">完成银行卡绑定后才能进行业务操作</div>
    </div>
  </div>
</template>

<script>
import fetchPost from "@/api/http.js";
import bankArr from "@/utils/bank.js";
export default {
  // props: ["tabOptions", "currPage"],
  data() {
    return {
      msg: "111",
      cards: [],
    };
  },
  mounted() {
    this.queryBankCards();
    sessionStorage.removeItem('bankCardInfo')
  },
  methods: {
    addCard() {
      this.$router.push("/manage/AddCard");
    },
    activeCard(bankCardInfo) {
      sessionStorage.setItem('bankCardInfo', JSON.stringify(bankCardInfo))
      this.$router.push("/manage/AddCard");
    },
    queryBankCards() {
      fetchPost("/saas/shipperOrderController/queryBankListBill", {}).then(result => {
        if(result){
          var res = result.obj
           for(var i = 0 ; i<res.length;i++){
             res[i].background = "#D95757";
             res[i].imgSrc = "/bankIcon/tongyong.png";
              for(var j = 0 ; j<bankArr.length;j++){
                if(res[i].bankName == bankArr[j].name){
                    res[i].background = bankArr[j].background;
                    res[i].imgSrc = bankArr[j].imgSrc;
                }
              }
           }
           this.cards = res.filter(ele => ele.status !== 2)
        }
      });
    },
    handleDelete () {
      this.$confirm('确定要删除此张银行卡吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    }
  }
};
</script>

<style lang="less" scoped>
.clearfix:after {
    content: "";
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  
  .clearfix:after {
    *zoom: 1;
    /*针对IE6/IE7*/
  }
.f_l {
  float: left;
}
.f_16 {
  font-size: 16px;
}
.m_b16 {
  margin-bottom: 16px;
}
.m_r12 {
  margin-right: 12px;
}
.m_l12 {
  margin-left: 12px;
}
.content_box {
  color: #000;
  font-family: PingFangSC-Medium;
  .content_title{
    // padding: 24px 32px !important;
    height: 90px;
    background: #f1f1f1;
    box-sizing: border-box;
  }
  .card_box {
    padding: 0 32px !important;
    padding-bottom: 34px !important;
    border-bottom: 1px solid #e9e9e9;
    .card_item {
      position: relative;
      float: left;
      width: 320px;
      height: 184px;
      background: #f6f6f6;
      border: 1px solid #ebebeb;
      border-radius: 4px;
      margin-right: 15px !important;
      margin-bottom: 15px !important;
      .card_plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
      }
    }
    .hasCard {
      background: #d95757;
      color: #fff;
      padding: 24px !important;
      box-sizing: border-box;
      .item_content {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 22px;
        color: #ffffff;
      }
    }
    .bankIcon{
      width: 26px;
      height: 26px;
      margin-right: 10px !important;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .toActive {
      background: #d95757;
      opacity: 0.45;
      color: #fff;
      padding: 24px !important;
      box-sizing: border-box;
      .item_content {
        flex: 1;
        font-family: PingFangSC-Medium;
        font-size: 22px;
        color: #ffffff;
      }
    }
  }
  .tips_box {
    margin-top: 24px !important;
    margin-left: 48px !important;
    margin-bottom: 24px !important;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.45);
  }
}
</style>